import React from 'react';
import { useParams } from 'react-router-dom';
import EighthFloor from "./EighthFloor";
import NinthFloor from "./NinthFloor";
import TenthFloor from "./TenthFloor";

const Floor = ({
  scale,
  desktop,
  backgroundColor,
  eighthFloorRooms,
  ninthFloorRooms,
  tenthFloorRooms,
}) => {
  
  const { floorNumber } = useParams();
  const floor = Number(floorNumber);

  switch (floor) {
    case 8:
      return (
        <EighthFloor
          scale={scale}
          desktop={desktop}
          backgroundColor={backgroundColor}
          rooms={eighthFloorRooms}
        />
      );
    case 9:
      return (
        <NinthFloor
          scale={scale}
          desktop={desktop}
          backgroundColor={backgroundColor}
          rooms={ninthFloorRooms}
        />
      );
    case 10:
      return (
        <TenthFloor
          scale={scale}
          desktop={desktop}
          backgroundColor={backgroundColor}
          rooms={tenthFloorRooms}
        />
      );
    default:
      return null;
  }
};

export default Floor;